// App.jsx
import React, { useEffect } from "react";
import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";
import "./tour.css";

const Tour = ({ id, lista }) => {

  useEffect(() => {
    if (!id || !lista || lista.length === 0) return;

    const hasSeen = localStorage.getItem(id)
    if (!hasSeen) {
      startTour();
    }
  }, [lista]); // <- ATUALIZA SE A LISTA MUDAR
  
  const finalizarTour =()=>{
    localStorage.setItem(id, "yes");
  }
  
  const startTour = () => {
    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: "tour-card",
        scrollTo: false,
        cancelIcon: { enabled: true },
        modalOverlayOpeningPadding: 6,
        modalOverlayOpeningRadius: 10
      }
    });

    const closeActiveSteps = (exceptStep) => {
      tour.steps.forEach(s => {
        try {
          if (s !== exceptStep && s.isActive()) s.hide(); finalizarTour();
        } catch (_) {}
      });
    };

    const safeNext = () => {
      const current = tour.getCurrentStep();
      if (current) {
        try { current.hide(); } catch (_) {}
      }
      setTimeout(() => {
        try { tour.next(); } catch (_) {}
      }, 40);
    };

    const safeBack = () => {
      const current = tour.getCurrentStep();
      if (current) {
        try { current.hide(); } catch (_) {}
      }
      setTimeout(() => {
        try { tour.back(); } catch (_) {}
      }, 40);
    };

    const beforeShowHandler = function () {
      closeActiveSteps(this);
    };

    /** -----------------------------------------
     *  🔥 AQUI ESTÃO OS STEPS COM INDEX CORRETO
     * ----------------------------------------- */
    lista.forEach((item, index) => {
      tour.addStep({
        id: `step${index}`,
        text: `
          <div style="
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 8px;
            border-top-right-radius: 30%;
            border-bottom-left-radius: 30%;
            padding: 12px;
          ">
            ${item?.titulo}
          </div>
          <div style="
            color: #555;
            border-top-right-radius: 30%;
            border-bottom-left-radius: 30%;
            padding: 12px;
          ">
            ${item?.descricao}
          </div>
        `,
        attachTo: { element: item?.id, on: "bottom" },
        when: { "before-show": beforeShowHandler },
        buttons: [
          ...(!!item?.prev ? [{
            text: "Voltar",
            action: safeBack,
            classes: "shepherd-button shepherd-button-secondary"
          }]:[]),
          ...(!!item?.next ? [{
            text: "Próximo",
            action: safeNext,
            classes: "shepherd-button shepherd-button-primary"
          }]:[]),
          ...(!!item?.finish ? [{
            text: "Concluir",
            action: () => {
              const cur = tour.getCurrentStep();
              if (cur) {
                try { cur.hide(); } catch (_) {}
              }
              setTimeout(() => {
                try { tour.complete(); finalizarTour(); } catch (_) {}
              }, 40);
            },
            classes: "shepherd-button shepherd-button-primary"
          }]:[])
        ]
      });
    });

    tour.on("show", () => {
      closeActiveSteps(tour.getCurrentStep());
    });

    tour.start();
  };

  return null
};

export default Tour;